module.exports = __webpack_public_path__ + "assets/images/direction.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/direction.png
// module id = 1514
// module chunks = 1